import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_ctx.model)
    ? (_openBlock(), _createBlock(_component_modal_box, {
        key: 0,
        "is-visible": true,
        title: _ctx.Resources.AccountSettings.ChangePasswordTitle,
        icon: "user-cog",
        width: "narrow"
      }, {
        actions: _withCtx(() => [
          _createElementVNode("a", {
            href: "",
            class: "gfu-link gfu-link--accent gfu-link--inline _mb-1",
            onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
            "data-qa": "modal-button:Cancel"
          }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--wide gfu-btn--compact _ml-3 _mt-1",
            onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => ($options.submit && $options.submit(...args)), ["prevent"])),
            "data-qa": "modal-button:Confirm"
          }, _toDisplayString(_ctx.Resources.Common.ModalConfirmButton), 1 /* TEXT */)
        ]),
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_ctx.Resources.AccountSettings.ChangePasswordInfoText), 1 /* TEXT */),
          _createVNode(_component_text_field, {
            modelValue: _ctx.model.newPassword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model.newPassword) = $event)),
            "display-name": _ctx.Resources.AccountSettings.ChangePasswordNewPasswordFieldLabel,
            type: "password",
            name: "model.newPassword",
            onKeyup: _withKeys(_withModifiers($options.submit, ["prevent","stop"]), ["enter"]),
            "data-qa": "modal-field:NewPassword"
          }, null, 8 /* PROPS */, ["modelValue", "display-name", "onKeyup"]),
          _createVNode(_component_text_field, {
            modelValue: _ctx.model.repeatNewPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.model.repeatNewPassword) = $event)),
            "display-name": _ctx.Resources.AccountSettings.ChangePasswordConfirmNewPasswordFieldLabel,
            type: "password",
            name: "model.repeatNewPassword",
            onKeyup: _withKeys(_withModifiers($options.submit, ["prevent","stop"]), ["enter"]),
            "data-qa": "modal-field:RepeatPassword"
          }, null, 8 /* PROPS */, ["modelValue", "display-name", "onKeyup"]),
          _createElementVNode("p", null, _toDisplayString(_ctx.Resources.AccountSettings.ChangePasswordCurrentPasswordText), 1 /* TEXT */),
          _createVNode(_component_text_field, {
            modelValue: _ctx.model.oldPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.model.oldPassword) = $event)),
            "display-name": _ctx.Resources.AccountSettings.ChangePasswordCurrentPasswordFieldLabel,
            type: "password",
            name: "model.oldPassword",
            onKeyup: _withKeys(_withModifiers($options.submit, ["prevent","stop"]), ["enter"]),
            "data-qa": "modal-field:Password"
          }, null, 8 /* PROPS */, ["modelValue", "display-name", "onKeyup"]),
          _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title"]))
    : _createCommentVNode("v-if", true)
}